$(function () {
    if ($(".accomodationlister")[0]) {
        $(".js_acco_filter").on("click", function () {
            const urlParams = new URLSearchParams(window.location.search);
            if ($(this).hasClass("active")) {
                var key = $(this).data('filtertype').split("=")[0];
                var value = $(this).data('filtertype').split("=")[1];
                if (urlParams.get(key)) {
                    if (key == "features") {
                        var features = urlParams.get(key).split(",")
                        features = jQuery.grep(features, function (val) {
                            return val != value;
                        });
                        urlParams.set("features", features.join(","))
                        window.location.search = urlParams;

                    } else {
                        var newsearch = window.location.search.replace("&" + key + "=" + value, "");
                        newsearch = newsearch.replace("?" + key + "=" + value, "");
                        window.location.search = newsearch;
                    }
                }
            } else {
                var item = $(this).data("filtertype");
                if (
                    urlParams.get("features") != null &&
                    item.split("=")[0] == "features"
                ) {
                    if (
                        !urlParams.get("features").split(",").includes(item.split("=")[1])
                    ) {
                        urlParams.set(
                            "features",
                            urlParams.get("features") + "," + item.split("=")[1]
                        );
                    }
                } else {
                    urlParams.set(item.split("=")[0], item.split("=")[1]);
                }

                window.location.search = urlParams;
            }
        })

        let params = new URLSearchParams(document.location.search.substring(1));

        if (params) {
            params.forEach(function (value, key) {
                if (key == "features") {
                    value.split(",").forEach(function (val) {
                        $(".filter[data-filtertype='" + key + "=" + val + "']").addClass("active");
                    })
                } else if (key == "location") {
                    $(".lister #locationbookingstrip").val(value)
                } else {
                    $(".filter[data-filtertype='" + key + "=" + value + "']").addClass("active");
                }
            });

            var sortedfilters = $('.filter').sort(function (lhs, rhs) {
                return $(rhs).hasClass("active") - $(lhs).hasClass("active");
            });

            var order = 1;
            $.each(sortedfilters, function (idx, itm) {
                $(this).css("order", order);
                order += 1;
            });
        }
    }
});
